export default __webpack_public_path__ + "static/media/personaltagnew.ecac6fc3.svg";